import { useSelector } from "react-redux";
import {
  CampaignRecommendations,
  type SimilarSalesProps,
} from "~/feature/SaleRecommendations/CampaignRecommendations/CampaignRecommendations";
import type { RootState } from "~/redux/store";
import { SearchPageType, useSearchPageType } from "~/Search/useSearchPageType";

export const SRPCampaignRecommendations = (props: Omit<SimilarSalesProps, "products" | "variant">) => {
  const products = useSelector((state: RootState) => {
    return state.srp.productsOnSale.map((code) => state.products.basic[code]);
  });

  const inFlight = useSelector((state: RootState) => {
    return state.srp.inFlight;
  });

  const pageType = useSearchPageType();
  if (!(pageType === SearchPageType.SEARCH)) {
    return null;
  }

  return <CampaignRecommendations {...props} variant={"SRP"} products={products} loading={inFlight} />;
};
